module.exports = {
  'en': {
    'HRES6KEC1': {
      '5': 'Start Request Date',
      '7': 'To',
      '10': 'Request Date',
      '20': 'Seq. No',
      '30': 'O.T req.no.',
      '40': 'O.T Period',
      '50': 'Status',
      '60': 'Remark',
      '70': 'Last Approve By',
      '80': 'Next Step Approval'
    },
    'HRES6KEC2': {
      '10': 'Request Date',
      '15': 'Req. No.',
      '20': 'O.T. Period',
      '30': 'Form Date',
      '40': 'To',
      '50': 'O.T. Time',
      '60': 'Before Work',
      '70': 'Holiday Work',
      '80': 'After Work',
      '90': 'Reason of request',
      '95': 'Remark',
      '99': 'Request for Details of O.T',
      '100': 'Approve By Next Step',
      '110': 'Actual Time in-out',
      '120': 'Update By'
    }
  },
  'th': {
    'HRES6KEC1': {
      '5': 'วันที่ขอตั้งแต่',
      '7': 'ถึง',
      '10': 'วันที่ขอ',
      '20': 'ลำดับที่',
      '30': 'เลขที่ใบขอ',
      '40': 'ช่วงวันที่ขอ O.T',
      '50': 'สถานะ',
      '60': 'หมายเหตุ',
      '70': 'ผู้อนุมัติล่าสุด',
      '80': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES6KEC2': {
      '10': 'วันที่ขอ',
      '15': 'ลำดับที่',
      '20': 'ช่วงวันที่ขอ O.T.',
      '30': 'ตั้งแต่วันที่',
      '40': 'ถึง',
      '50': 'เวลาขอ O.T',
      '60': 'ก่อนเวลาทำงาน',
      '70': 'ทำงานวันหยุด',
      '80': 'หลังเวลาทำงาน',
      '90': 'สาเหตุการขอ',
      '95': 'รายละเอียด',
      '99': 'คำร้องเรื่อง การขอทำงานล่วงเวลา',
      '100': 'อนุมัติโดยข้ามขั้นตอน',
      '110': 'รายละเอียดเวลาปฏิบัติงาน',
      '120': 'ผู้บันทึก'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6ke.js